import React, { useCallback, useEffect, useState } from 'react';

import { SnackBarType } from 'types';

import { useModalContext } from 'common/Context/ModalContext';

import styles from './Snackbar.module.scss';

type Props = {
  snackBar: SnackBarType;
  isInItemDetails?: boolean;
};

const Snackbar: React.FC<Props> = ({ snackBar, isInItemDetails }) => {
  const { closeSnackBar } = useModalContext();
  const { time, type, callback } = snackBar;
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    setVisible(true);

    if (time !== -1) {
      setTimeout(() => {
        setVisible(false);

        setTimeout(() => {
          closeSnackBar(snackBar.id);
        }, 300);
      }, time);
    }
  }, [snackBar.id, closeSnackBar, time]);

  const getIcon = useCallback((): string => {
    switch (type) {
      case 'SUCCESS':
        return 'mm-check-circle-o';
      case 'INFO':
        return 'mm-info-circle';
      default:
        return 'mm-check-circle-o';
    }
  }, [type]);

  const getTypeCSS = useCallback((): string => {
    switch (type) {
      case 'SUCCESS':
        return styles.Success;
      case 'INFO':
        return styles.Info;
      default:
        return styles.Success;
    }
  }, [type]);

  const getItemDetailsCSS = useCallback((): string => {
    if (isInItemDetails) {
      return styles.InItemDetails;
    }
    return '';
  }, [isInItemDetails]);

  const SnackbarDialog = (
    <dialog
      className={`${styles.Outer} ${getTypeCSS()} ${visible ? styles.Visible : ''} ${getItemDetailsCSS()}`}
      data-testid="snackbar"
    >
      <i className={getIcon()} />
      {snackBar.text}
    </dialog>
  );

  if (callback) {
    return (
      <button type="button" onClick={callback} id="snackbar-button">
        {SnackbarDialog}
      </button>
    );
  }

  return SnackbarDialog;
};

export default Snackbar;
